import React from 'react';
import {Trans} from 'react-i18next';
import {Entry, TimelineEntry} from './Shared';

export const CustomerDeletedTimelineEntry = ({entry}) => {
    return (
        <TimelineEntry entry={entry} status="delete" icon="person">
            <Entry.Title>
                <Trans i18nKey="warehousing.timeline.CustomerDeleted.title" values={{name: entry.customerName}} />
            </Entry.Title>
        </TimelineEntry>
    );
};
